import React, { useEffect } from "react";
import { useNavigate } from "react-router";
import { toast } from "react-toastify";
import { useUiStateStore } from "store/ui-state";
import FallbackUI from "./fallback-ui";

const withAdminAuth = (Component, allowedCompanyRoles = []) => {
  return (props) => {
    const {
      userLoggedIn: { userInfo },
    } = useUiStateStore();
    const navigate = useNavigate();

    // Check if user is administrator
    const isAdmin = userInfo?.system_role?.toLowerCase() === "administrator";

    // Check if user has allowed company role
    const hasAllowedCompanyRole =
      allowedCompanyRoles.length === 0 ||
      allowedCompanyRoles.includes(userInfo?.company_role?.name);

    // Single condition to check authorization
    const isAuthorized = isAdmin || hasAllowedCompanyRole;

    useEffect(() => {
      if (!isAuthorized) {
        toast.error("Forbidden Access!");
        navigate("/profile");
      }
    }, [isAuthorized, navigate]);

    if (!isAuthorized) {
      return <FallbackUI />;
    }

    return <Component {...props} />;
  };
};

// Strict variant: only system_role administrator. Used by pages that must never be
// visible to other company roles (for example Audit Logs).
const withAdminOnly = (Component) => {
  return (props) => {
    const {
      userLoggedIn: { userInfo },
    } = useUiStateStore();
    const navigate = useNavigate();

    const isAdmin = userInfo?.system_role?.toLowerCase() === "administrator";

    useEffect(() => {
      if (!isAdmin) {
        toast.error("Forbidden Access!");
        navigate("/profile");
      }
    }, [isAdmin, navigate]);

    if (!isAdmin) return <FallbackUI />;
    return <Component {...props} />;
  };
};

export { withAdminOnly };
export default withAdminAuth;
